import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import FaCaretDown from 'react-icons/lib/fa/caret-down';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MdClose from 'react-icons/lib/md/close';
import './style.scss';

@observer
class FormSelectField extends Component {
    @observable expanded = false;

    constructor() {
        super();
        this.containerRef = React.createRef();
    }

    @action setExpanded = (val) => {
        this.expanded = val;
    };

    @action toggleExpanded = () => {
        this.expanded = !this.expanded;
    };

    @action closeExpanded = () => {
        this.expanded = false;
    };

    @action handleChange = (item, index, state = true) => {
        const {onChange, closeOnSelect = true} = this.props;
        onChange(item, index, state);
        if (closeOnSelect) this.toggleExpanded();
    };

    renderListItems() {
        const {options, disableDelete, singleSelect = false} = this.props;
        const menuItemClasses = {
            root: 'select-menu-text-wrap',
            primary: 'select-menu-text'
        };
        const iconClasses = {
            icon: 'select-menu-icon'
        };
        const buttonClasses = {
            root: 'select-menu-button'
        };

        const selectedMenuItemClasses = {
            root: 'select-menu-text-wrap',
            primary: 'select-menu-text selected'
        };

        return options.map((item, index) => {
            return (<ListItem
                key={index}
                button
                disabled={item.selected}
                onClick={() => { if (!item.selected) { this.handleChange(item, index); } }}
                className="select-menu-item">
                {item.icon && <img className={iconClasses.icon} src={item.icon} alt=""/>}
                <ListItemText classes={singleSelect && item.selected ? selectedMenuItemClasses : menuItemClasses} primary={item.label || item.value}/>
                {!singleSelect && item.selected && !disableDelete &&
                <ListItemSecondaryAction>
                    <IconButton classes={buttonClasses} disableRipple={true} onClick={() => this.handleChange(item, index, false)}>
                        <MdClose/>
                    </IconButton>
                </ListItemSecondaryAction>}
            </ListItem>);
        });
    }

    render() {
        const {value, label, title, options, disabled, icon, placeholder, className, closeOnSelect = true, isSelected = false, withLabel = true} = this.props;
        const panelClasses = {
            root: 'select-panel',
            expanded: 'select-expanded'
        };
        const summaryClasses = {
            root: 'select-summary',
            expanded: 'select-summary-expanded',
            content: 'select-summary-content',
            expandIcon: 'select-summary-icon'
        };
        const selectedMenuItem = options.find(item => item.selected) || {label: ''};
        const container = this.containerRef.current;
        const activeIndex = options.findIndex(item => item.label === value);
        if (container && !icon && closeOnSelect) {
            const activeItem = container.querySelector(`.select-menu-item:nth-child(${activeIndex + 1})`);
            const scrollableList = container.querySelector('.select-menu');
            scrollableList.scrollTop = activeItem ? activeItem.offsetTop : 0;
        }

        return (
            <ClickAwayListener onClickAway={this.closeExpanded}>
                <div className={className ? `${className} select-container` : 'select-container'} ref={this.containerRef}>
                    {label && withLabel && <div className="select-label">{label}</div>}
                    <ExpansionPanel disabled={disabled} classes={panelClasses} expanded={this.expanded}>
                        <ExpansionPanelSummary
                            className={!value ? 'placeholder' : ''}
                            classes={summaryClasses}
                            onClick={this.toggleExpanded}
                            expandIcon={<FaCaretDown/>}>
                            {icon && <img className="selected-icon" src={icon} alt=""/>}
                            <span className={`selected-label ${isSelected ? 'active' : ''}`}>
                                {value || selectedMenuItem.label || placeholder}
                            </span>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="select-menu">
                            {title && <div className="select-menu-title">{title}</div>}
                            <List dense className="select-menu-list">
                                {
                                    this.renderListItems()
                                }
                            </List>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
            </ClickAwayListener>
        );
    }
}

export default FormSelectField;
